import React from 'react';
import { rgba, scssVariables } from 'src/helpers';

export const File = React.memo(() => (
  <>
    <g transform='translate(16,16) scale(1.07) translate(-16,-16)'>
      <path
        fill={rgba(scssVariables['colors-mc-primary'], 0.5)}
        d='M23.5,2h-12a.47.47,0,0,0-.35.15l-5,5A.47.47,0,0,0,6,7.5v20A2.5,2.5,0,0,0,8.5,30h15A2.5,2.5,0,0,0,26,27.5V4.5A2.5,2.5,0,0,0,23.5,2Z'
      ></path>
      <path
        fill={scssVariables['colors-mc-primary']}
        d='M11.69,2a.47.47,0,0,0-.54.11l-5,5A.47.47,0,0,0,6,7.69.5.5,0,0,0,6.5,8h3A2.5,2.5,0,0,0,12,5.5v-3A.5.5,0,0,0,11.69,2Z'
      ></path>
      <path
        fill={scssVariables['colors-mc-primary']}
        d='M18.5,15.5h-2v-2a.5.5,0,0,0-1,0v2h-2a.5.5,0,0,0,0,1h2v2a.5.5,0,0,0,1,0v-2h2a.5.5,0,0,0,0-1Z'
      ></path>
    </g>
  </>
));
File.displayName = 'File';
